import Navbar from './components/Navbar';
import HeroSection from './components/Herosection';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Portfolio() {
  return (
    <div className="min-h-screen bg-white text-slate-800">
      <Navbar />
      <HeroSection />
      <About />
      <Skills />
      <Experience />
      <Projects/>
      <Contact/>
    <Footer/>

      {/* Remaining sections will be added here one by one as separate components */}
    </div>
  );
}